<mat-form-field appearance="outline">
  <input
    matInput
    type="text"
    [attr.aria-label]="ariaLabelledby ? null : 'Color picker'"
    [attr.aria-labelledby]="ariaLabelledby"
    placeholder="Enter a color..."
    id="{{ pickerId }}"
    #colorInput
    (ngModelChange)="onColorChange($event)"
    [(ngModel)]="color"
    [disabled]="disabled"
  />
</mat-form-field>
